/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import "components/competency/competency.css";
import { Trans } from "react-i18next";

class CompetencyItem extends Component {
  rowClassName = "";

  state = {
    showingTabletDetail: false,
    showingPersonnels: [],
  };

  toggleTabletDetail = (idx) => {
    let showing = this.state.showingTabletDetail;
    this.setState({ showingTabletDetail: !showing });
    this.togglePersonnels(idx);
  };

  togglePersonnels = (idx) => {
    let showingPersonnels = [...this.state.showingPersonnels];
    showingPersonnels[idx] = !showingPersonnels[idx];
    showingPersonnels.forEach((sp, i) => {
      if (i !== idx) showingPersonnels[i] = false;
    });
    this.setState({ showingPersonnels });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };
  renderTabletModeDetail = (t) => {
    if (!this.state.showingTabletDetail) return null;

    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            {/* <tr data-dt-row="0" data-dt-column="5">
              <td>
                <div className="tableTitle">Personel</div>
              </td>
              <td>{t.position?.name}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="3">
              <td>
                <div className="tableTitle">Ünvan</div>
              </td>
              <td>{t.workStatus?.label}</td>
            </tr> */}
            <tbody>
              <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Gerekli Personel">10169</Trans>
                  </div>
                </td>
                <td>{t.shouldBeQuantity}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Mevcut Personel">10170</Trans>
                  </div>
                </td>
                <td>{t.currentEmployeeCount}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Pozisyon Ağırlığı">10171</Trans>
                  </div>
                </td>
                <td>{t.weight}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  renderPositionEfficiency = (pe) => {
    return (
      <div className="kbETOGraphic" id="kbETOGraphic_4">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg">
            <g>
              <rect x="0" y="0" width="100%" height="20" fill="#eeeeee"></rect>
              <rect
                x="0"
                y="0"
                width={`${pe.positionQualification}%`}
                height="20"
                fill="#68b8dc"
              ></rect>
              <text
                x="80%"
                y="14"
                fontFamily="Verdana"
                fontSize="9"
                fill="black"
                textAnchor="end"
              >
                <Trans desc="Mevcut ETO">10172</Trans>
              </text>
              <text x="2" y="14" fontFamily="Verdana" fontSize="9" fill="black">
                {Number(pe.positionQualification.toFixed(2))}
              </text>
            </g>
            <g>
              <rect x="0" y="20" width="100%" height="20" fill="#eeeeee"></rect>
              <rect
                x="0"
                y="20"
                width={`${pe.positionFutureQualification}%`}
                height="20"
                fill="#af46d1"
              ></rect>
              <text
                x="80%"
                y="34"
                fontFamily="Verdana"
                fontSize="9"
                fill="black"
                textAnchor="end"
              >
                <Trans desc="Gelecek ETO">10173</Trans>
              </text>
              <text x="2" y="34" fontFamily="Verdana" fontSize="9" fill="black">
                {Number(pe.positionFutureQualification.toFixed(2))}
              </text>
            </g>
          </svg>
        </div>
      </div>
    );
  };

  renderPersonnels = () => {
    // console.log(this.state.showingPersonnels);
    if (!this.props.personnels) return null;
    return this.props.personnels.map((p) => {
      return (
        // <tr key={p.id} className="grupEgitim_1 spanHide">
        <tr
  key={p.id}
  className="grupEgitim_1 spanHide"
  style={{
    backgroundColor:
      p.tesvikStatus === "true"
        ? "#EDF7F1" // Soft Kurumsal Yeşil
        : "#FDF2F2", // Soft Kurumsal Kırmızı
    color: "#2F3A45",
    transition: "all 0.25s ease"
  }}
>
          <td></td>
          <td>{p.fullname}</td>
          <td>{p.position.name}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <DesktopBreakpoint>
              <div className="kbETOGraphic" id="kbETOGraphic_4">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <rect
                        x="0"
                        y="0"
                        width="100%"
                        height="20"
                        fill="#eeeeee"
                      ></rect>
                      <rect
                        x="0"
                        y="0"
                        width={`${p.qualifications}%`}
                        height="20"
                        fill="#68b8dc"
                      ></rect>
                      <text
                        x="80%"
                        y="14"
                        fontFamily="Verdana"
                        fontSize="9"
                        fill="black"
                        textAnchor="end"
                      >
                        <Trans desc="Mevcut ETO">10172</Trans>
                      </text>
                      <text
                        x="2"
                        y="14"
                        fontFamily="Verdana"
                        fontSize="9"
                        fill="black"
                      >
                        {p.qualifications}
                      </text>
                    </g>
                    <g>
                      <rect
                        x="0"
                        y="20"
                        width="100%"
                        height="20"
                        fill="#eeeeee"
                      ></rect>
                      <rect
                        x="0"
                        y="20"
                        width={`${p.futureQualifications}%`}
                        height="20"
                        fill="#af46d1"
                      ></rect>
                      <text
                        x="80%"
                        y="34"
                        fontFamily="Verdana"
                        fontSize="9"
                        fill="black"
                        textAnchor="end"
                      >
                        <Trans desc="Gelecek ETO">10173</Trans>
                      </text>
                      <text
                        x="2"
                        y="34"
                        fontFamily="Verdana"
                        fontSize="9"
                        fill="black"
                      >
                        {p.futureQualifications}
                      </text>
                    </g>
                  </svg>
                </div>
              </div>
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <div style={{ minWidth: "60px" }}>ETO: {p.qualifications}</div>
              <div style={{ minWidth: "60px" }}>G.ETO: {p.futureQualifications}</div>
            </TabletBreakpoint>
          </td>
          <td></td>
        </tr>
      );
    });
  };

  togglePersonnels = (idx) => {
    let showingPersonnels = [...this.state.showingPersonnels];
    showingPersonnels[idx] = !showingPersonnels[idx];
    showingPersonnels.forEach((sp, i) => {
      if (i !== idx) showingPersonnels[i] = false;
    });
    this.setState({ showingPersonnels });
  };

  render() {
    const { pe, idx } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <React.Fragment key={pe.id}>
            <tr
              key={pe.id}
              className="grupEgitim hasChild"
              onClick={() => this.togglePersonnels(idx)}
            >
              <td colSpan="3" className="showGrup">
                {pe.name}
              </td>
              <td className="showGrup"></td>
              <td className="showGrup"></td>
              <td className="showGrup">{pe.requiredEmployee}</td>
              <td className="showGrup">{pe.shouldBeQuantity}</td>
              <td className="showGrup">{pe.currentEmployeeCount}</td>
              <td className="showGrup">{pe.weight}</td>
              <td className="showGrup">{this.renderPositionEfficiency(pe)}</td>
              <td className="showGrup openCloseBtn">
                <span className="iconmford fo-icon-add"></span>
              </td>
            </tr>
          </React.Fragment>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleTabletDetail(idx)}
          >
            <td className="showGrup">{pe.name}</td>
            <td className="showGrup openCloseBtn tbltOpener">
              <span className="iconmford fo-icon-add"></span>
            </td>
          </tr>
          {this.renderTabletModeDetail(pe)}
        </TabletBreakpoint>
        {this.state.showingPersonnels[idx] ? (
          <tr className="child">
            <td className="child" colSpan="8">
              <table className="table">
                <tbody>{this.renderPersonnels(idx)}</tbody>
              </table>
            </td>
          </tr>
        ) : null}
      </>
    );
  }
}

export default CompetencyItem;
